module.exports = __webpack_public_path__ + "img/index14.b49971ac.svg";